import { Chip, ChipProps, styled } from '@mui/material';

import { doNotForwardTheseProps } from '@/styles/utils';

export const LabelBadge = styled(
  (props: ChipProps) => <Chip size="small" {...props} />,
  {
    shouldForwardProp: doNotForwardTheseProps('mr', 'ml'),
  },
)<{ mr?: number; ml?: number }>(({ theme, mr = 0, ml = 0 }) => ({
  backgroundColor: theme.palette.primaries[100],
  color: theme.palette.primaries[500],
  fontSize: theme.typography.caption2Bold.fontSize,
  fontWeight: theme.typography.caption2Bold.fontWeight,
  borderRadius: 16,
  height: 16,
  marginLeft: theme.spacing(ml),
  marginRight: theme.spacing(mr),
  textTransform: 'uppercase',
  '.MuiChip-label': {
    paddingLeft: 5,
    paddingRight: 5,
  },
}));
